export const MANAGEEULA = 'MANAGEEULA'